import { onError, onSuccess } from "../../../../utils/http";
import { errorNotification, successNotification } from "../../../../utils/notification";
import {
    DELETE_RT_PROJECT_TYPE,
    GET_ALL_RT_PROJECT_TYPE,
    POST_RT_PROJECT_TYPE,
    PUT_RT_PROJECT_TYPE,
    SET_ALL_RT_PROJECT_TYPE,
} from "../../constants";

import { FINANCIAL_RT_ENDPOINT } from "../../constants/endpoint";

export const getAllProjectType = () => {
    return {
        type: GET_ALL_RT_PROJECT_TYPE,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/projectType`,
        },
        meta: {
            onSuccess: (response, requestAction, store) => {
                store.dispatch(setAllProjectType(response.data));
                return response;
            },
        },
    };
};

export const setAllProjectType = (data) => {
    return {
        type: SET_ALL_RT_PROJECT_TYPE,
        payload: data,
    };
};

export const postProjectType = (projectType) => {
    return {
        type: POST_RT_PROJECT_TYPE,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/projectType`,
            method: 'post',
            data: projectType
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "create_success");
                store.dispatch(getAllProjectType());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', "create_error");
                throw error;
            })
        }
    };
};

export const putProjectType = (id, projectType) => {
    return {
        type: PUT_RT_PROJECT_TYPE,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/projectType/${id}`,
            method: 'put',
            data: projectType
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "update_success");
                store.dispatch(getAllProjectType());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', "update_error");
                throw error;
            })
        }
    };
};

export const deleteProjectType = (id) => {
    return {
        type: DELETE_RT_PROJECT_TYPE,
        request: {
            url: `${FINANCIAL_RT_ENDPOINT}/projectType/${id}`,
            method: 'delete'
        },
        meta: {
            onSuccess: onSuccess(({ response, store }) => {
                successNotification('', "delete_success");
                store.dispatch(getAllProjectType());
                return response;
            }),
            onError: onError(({ error }) => {
                errorNotification('', error.response.status === 409 ? "ressource_in_use_error" : "delete_error");
                throw error;
            })
        }
    };
};
